export function ellipsis(str = '', { start = 25, end = 0 } = {}): string {
  if (str.length <= start + end) {
    return str
  }
  return `${str.substring(0, start)}…${str.substring(str.length - end, str.length)}`
}

export function cleanChar(text, char = '`'): string {
  return text?.replace(new RegExp(char, 'g'), '')
}

export function caseInsensitiveEquals(a: string, b: string | undefined): boolean {
  return a === b || a.toLowerCase() === b?.toLowerCase()
}

export function caseInsensitiveFind(list: string[], value: string): string | undefined {
  return list.find((item) => caseInsensitiveEquals(item, value))
}

export function caseInsensitiveIncludes(list: string[], value: string): boolean {
  return caseInsensitiveFind(list, value) !== undefined
}
